import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DoctorCard } from "./FindCare";
import { EmergencyBanner } from "@/components/shared/Common";

export default function Doctors() {
  const [doctors, setDoctors] = useState([]);
  useEffect(() => { api.get("/doctors").then(r => setDoctors(r.data)); }, []);
  return (
    <div className="cm-container py-12">
      <div className="mb-6"><EmergencyBanner compact /></div>
      <div className="mb-8">
        <div className="cm-eyebrow mb-2">Directory</div>
        <h1 className="cm-h2">Our verified doctors</h1>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="doctors-grid">
        {doctors.map(d => <DoctorCard key={d.id} d={d}/>)}
      </div>
    </div>
  );
}
